<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 22C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H19C20.5977 2 21.9037 3.24892 21.9949 4.82373L22 5V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H5ZM11 13H4V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H11V13ZM13 13H20V19L19.9933 19.1166C19.9355 19.614 19.5128 20 19 20H13V13ZM11 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V11H11V4ZM13 4H19L19.1166 4.00673C19.614 4.06449 20 4.48716 20 5V11H13V4Z"
    fill="currentColor"
  />
</svg>
